module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('p', [_vm._v("This is a basic example of a vue-plugin.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41dde93d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 81
// module chunks = 1